import { render, staticRenderFns } from "./IconEmail.vue?vue&type=template&id=ad7a601a"
import script from "./IconEmail.vue?vue&type=script&lang=js"
export * from "./IconEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports